import { Flex, Typography } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';

import { useSpecialsModal } from '@jane/business-admin/providers/SpecialsModalProvider';
import type { SpecialTypeConditionsInputProps } from '@jane/business-admin/types';

export const Bundle = ({
  isCreateMode,
  name,
  options,
}: SpecialTypeConditionsInputProps['bundle'] & {
  isCreateMode: boolean;
}) => {
  const {
    posSyncMap: { isJanePosSynced, posSynced },
    isReadOnly,
  } = useSpecialsModal();

  const { getValues } = useFormContext();
  const bundleValue = getValues('display.bundle');

  const showInputs = (isJanePosSynced || !posSynced) && !isReadOnly;

  return (
    <Flex
      justifyContent="space-between"
      width="100%"
      gap={24}
      flexDirection="column"
    >
      {options?.map((option) => {
        return isCreateMode || (!isCreateMode && showInputs) ? (
          <Flex width="100%" gap={24} mb={24} key={option.value}>
            <Form.NumberField
              width={'100%'}
              name={`${name}.${option.value}`}
              label={option.label}
              defaultValue={getValues(`${name}.${option.value}`)}
              min={1}
              required
              disableOnWheel
            />
          </Flex>
        ) : (
          <Flex gap={24} key={option.value}>
            <Flex width="50%" flexDirection="column">
              <Typography
                color="grays-black"
                variant="body-bold"
                data-testid={`non-janepos-synced-bundle-min-products-${
                  option.rule === 'required_rules' ? 'required' : 'discounted'
                }`}
              >
                {option.label}
              </Typography>
              <Typography color="grays-black" variant="body" mt={4}>
                {bundleValue?.[option.value] || 'N/A'}
              </Typography>
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};
